import React, { useEffect, useState } from "react";
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Chip, Card, CardContent, Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ShieldIcon from "@mui/icons-material/Shield";
import { fetchPrivileges, IPrivilege } from "../../../Api/rbacApi";
import { Loader } from "../../../Components/Loader";

const PrivilegeList: React.FC = () => {
  const [privileges, setPrivileges] = useState<IPrivilege[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPrivileges().then((data) => {
      setPrivileges(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <Loader height="60vh" />;

  return (
    <Box p={3}>
      {/* Header */}
      <Card elevation={0} sx={{ mb: 3, borderRadius: 3, background: "linear-gradient(135deg, #1a3353 0%, #2d5f8a 100%)", color: "#fff" }}>
        <CardContent sx={{ py: 3, px: 4 }}>
          <Stack direction="row" alignItems="center" gap={2}>
            <ShieldIcon sx={{ fontSize: 36, opacity: 0.9 }} />
            <Box>
              <Typography variant="h5" fontWeight={700}>Privileges</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>{privileges.length} modules available in the system</Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 3, border: "1px solid #e8e8e8" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#f8f9fa" }}>
              <TableCell sx={{ fontWeight: 700, color: "#1a3353", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5 }}>#</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a3353", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5 }}>Module Key</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a3353", fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5 }}>Display Name</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700, color: "#2196f3", fontSize: 13, textTransform: "uppercase" }}>View</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700, color: "#4caf50", fontSize: 13, textTransform: "uppercase" }}>Create</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700, color: "#ff9800", fontSize: 13, textTransform: "uppercase" }}>Edit</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700, color: "#f44336", fontSize: 13, textTransform: "uppercase" }}>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {privileges.map((p, i) => (
              <TableRow key={p.id} sx={{ bgcolor: i % 2 === 0 ? "#fff" : "#fafbfc", "&:hover": { bgcolor: "#f0f7ff" } }}>
                <TableCell sx={{ color: "#999", fontWeight: 600 }}>{i + 1}</TableCell>
                <TableCell>
                  <Chip
                    label={p.module}
                    size="small"
                    sx={{ fontFamily: "monospace", fontSize: 12, bgcolor: "#f0f4f8", color: "#1a3353", fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={600}>{p.display_name}</Typography>
                </TableCell>
                <TableCell align="center"><CheckCircleIcon fontSize="small" sx={{ color: "#2196f3" }} /></TableCell>
                <TableCell align="center"><CheckCircleIcon fontSize="small" sx={{ color: "#4caf50" }} /></TableCell>
                <TableCell align="center"><CheckCircleIcon fontSize="small" sx={{ color: "#ff9800" }} /></TableCell>
                <TableCell align="center"><CheckCircleIcon fontSize="small" sx={{ color: "#f44336" }} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PrivilegeList;
